import { useQuery } from 'react-query';

import * as copilot from 'api/copilot';

/**
 * Hook to query the Copilot configuration.
 *
 * @returns An object containing the Copilot configuration data, or `null` if Copilot is not available.
 */
export function useCopilotConfiguration() {
  const { data, ...queryInfo } = useQuery(['copilot', 'config'], () =>
    copilot.getCopilotConfiguration()
  );

  return {
    ...queryInfo,
    copilotConfiguration: data,
  };
}
